import axios from "axios";
import { confApp } from "./CONF_APP";

// API_URL: "https://api-pruebas.nefrosys.net/api/",
// baseURL: "https://api-pruebas.s-digitales.com/api/",
// baseURL: "https://localhost:7008/api/",

const axiosInstance = axios.create({
  baseURL: confApp.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.defaults.headers.post["Content-Type"] = "application/json";

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) ||
        "Error de conexión, algo salio mal!"
    )
);

export default axiosInstance;
